const KEY = "bp_visitor_state";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

export const getVisitorState = read;

export const setVisitorState = (patch) => {
  const next = { ...read(), ...patch };
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {}
  window.dispatchEvent(new CustomEvent("bp-state"));
  return next;
};

export const DISCOUNT_DURATION_MS = 15 * 60 * 1000;
export const CLEAR_HEAD_DISMISS_DAYS = 7;

export const isDiscountActive = () => {
  const s = read();
  return !!(s.discountClaimed && s.discountExpiresAt && Date.now() < s.discountExpiresAt);
};

export const discountRemainingMs = () => {
  const s = read();
  return Math.max(0, (s.discountExpiresAt || 0) - Date.now());
};
